import React, { useEffect, useState } from 'react';
import { Button, ModalBox, useModalContext } from '@fourthwall/components';
import { useDnsQuery } from '../../../../../../hooks/useDnsQuery';
import { useDeleteDomainMutation } from '../../queries/useDeleteDomainMutation';
export const ConfirmDomainConnectModal = ({ newDomainName, onConfirm, }) => {
    const { close } = useModalContext();
    const [refetchInterval, setRefetchInterval] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const { dnsQuery, invalidateDnsQuery } = useDnsQuery([], {
        refetchInterval,
    });
    const dnsList = dnsQuery.data?.dnsList;
    const { deleteDomainMutation } = useDeleteDomainMutation();
    const handleConfirmClick = () => {
        setIsLoading(true);
        deleteDomainMutation.mutate(undefined, {
            onSuccess: () => {
                invalidateDnsQuery();
                setRefetchInterval(1000);
            },
        });
    };
    useEffect(() => {
        if (dnsQuery.isSuccess && !dnsList) {
            setRefetchInterval(undefined);
            close();
            onConfirm();
        }
    }, [dnsQuery.isSuccess, dnsList]);
    return (React.createElement(ModalBox, { title: "Connecting domain", size: "small", buttons: [
            React.createElement(Button, { label: "Cancel", appearance: "secondary", onClick: close }),
            React.createElement(Button, { label: "Connect", appearance: "primary", loading: isLoading, onClick: handleConfirmClick }),
        ], onClose: close },
        React.createElement("div", null,
            "Connecting ",
            React.createElement("strong", null, newDomainName),
            " will remove your current domain",
            ' ',
            React.createElement("strong", null, dnsList?.domain),
            ".")));
};
